import SectionWindowSize from "../Sections/SectionWindowSize";
import SectionMountings2Lanes2Wings from "../Sections/SectionMountings2Lanes2Wings";
import { t } from "i18next";

function Window2Lanes2Wings() {
  return (
    <div>
      <SectionWindowSize
        widthMin={100}
        widthMax={240}
        widthStep={10}
        widthValue={200}
        widthEditable={true}
        widthInputTitle=""
        widthUnit={t("unit")}
        heightMin={100}
        heightMax={180}
        heightStep={10}
        heightValue={140}
        heightEditable={true}
        heightInputTitle=""
        heightUnit={t("unit")}
      />
      {/* <SectionMountings2Lanes2Wings
        horizontalStep={1}
        horizontalMin={0}
        horizontalMax={4}
        horizontalEditable
        verticalStep={1}
        verticalMin={0}
        verticalMax={4}
        verticalEditable
        selectedWing="left-wing"
      /> */}
    </div>
  );
}

export default Window2Lanes2Wings;
